import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_symbicognitive-labs/artifacts/9cao6tpi_SYMBICOGNITIVE%20Solutions%20Group.png";

// Official SymbiCognitive Solutions Group logo (navy background blends with nav/footer)
export const Logo = ({ className = "", imgClassName = "h-12 sm:h-14 w-auto" }) => {
  return (
    <div className={`flex items-center ${className}`} data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="SymbiCognitive Solutions Group"
        className={`${imgClassName} object-contain select-none`}
        draggable="false"
      />
    </div>
  );
};

export default Logo;
